import Storage from "../localStorage";
import DateFormat from "./dateFormat";
import Notify from "./notify";
import Metis from "../metis";
import {escapeMetisVariables, unescapeMetisReturnObject} from "./escapeMetis";

const dateFormat = new DateFormat();
const storage = new Storage();
const notify = new Notify();
const metis = new Metis();

const wp = wp_metis;

const addressFields = `
  id
  adressTyp {
    kurzbezeichnung
    langbezeichnung
  }
  hausnr
  anrede {
    kurzbezeichnung
    langbezeichnung
  }
  vorname
  nachname
  name1
  name2
  name3
  name4
  nametitel {
    kurzbezeichnung
    langbezeichnung
  }
  natkz
  ort
  plz
  str
  strzus
  coAnschrift
  standard
  ansprechpartnerAnrede {
    kurzbezeichnung
    langbezeichnung
  }
  ansprechpartnerVorname
  ansprechpartnerNachname
`;

const genderBirthdayFields = `
  id
  gebdat
  gebort
  geschlecht {
    kurzbezeichnung
    langbezeichnung
  }
`;

const commDataFields = `
  id
  komTyp {
    kurzbezeichnung
    langbezeichnung
  }
  ansprechpa
  komEmail
  rufNrFax
  rufNrFon
  rufNrMob
  standard
  adressdaten {
    ${addressFields}
  }
  geschlechtUndGeburtsdatum {
    ${genderBirthdayFields}
  }
`;

const bankDataFields = `
  id
  einzug
  kontoinh
  bank
  iban
  auslbankv
  bic
  standard
`;

const profileFields = `
  id
  identKey
  email
  anrede {
    kurzbezeichnung
    langbezeichnung
    sortierungsnr
  }
  nametitel {
    kurzbezeichnung
    langbezeichnung
    sortierungsnr
  }
  vorname
  nachname
  usernameOrg
  aktiviert
  rollen {
    name
  }
`;

class UserProfile {
  /**
   * Create a user profile
   *
   * @pram {object} data
   */
  async createProfile(data) {
    let {nametitel, anredeTyp, vorname, nachname, email, passwort} = data;
    [vorname, nachname] = escapeMetisVariables(vorname, nachname);

    const request = metis.metisRequest({
      query: `
        mutation {
            createProfil(
                mandantennummer: ${wp.mandantennummer},
                anmeldeEmail: "${email}",
                namtitleTyp: ${nametitel},
                anredeTyp: ${anredeTyp}
                password: "${passwort}",
                vorname: "${vorname}"
                nachname: "${nachname}"
            ) {
              ${profileFields}
            }
          }`,
    });

    const response = await request;
    if (response) {
      return response.createProfil;
    }
  }

  /**
   * Get user profile from Metis
   *
   * @returns object
   */
  async getUserProfile() {

    const request = metis.metisRequest({
      query: `
        query {
          getUserProfil{
            ${profileFields}
          }
        }
    `,
    });

    const response = await request;

    if (response) {
      return response.getUserProfil;
    }
  }

  async getAllUserProfile() {
    let request = null;

    request = metis.metisRequest({
      query: `
      query {
        getUserProfil {
          ${profileFields}
        }

        getUserAdressdaten {
          ${addressFields}
        }

        getUserKommunikationsdaten {
          ${commDataFields}
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response;
    }
  }

  async getGenderAndBirthday() {
    const request = metis.metisRequest({
      query: `
        query {
          getUserGeschlechtUndGeburtsdaten {
            ${genderBirthdayFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.getUserGeschlechtUndGeburtsdaten;
    }
  }

  /**
   * Get all user address data
   *
   * @returns
   */
  async getAllAddresses() {
    const request = metis.metisRequest({
      query: `
        query {
          getUserAdressdaten {
            ${addressFields}
          }
        }
        `,
    }, true, false, true);

    const response = await request;

    if (response) {
      return response.getUserAdressdaten;
    }
  }

  async getUserBankData() {
    const request = metis.metisRequest({
      query: `
        {
          getUserBankdaten {
            ${bankDataFields}
          }
        }
        `,
    });

    const response = await request;

    if (response) {
      return response.getUserBankdaten;
    }
  }

  /**
   * Update user Personal Data
   *
   * @param {object} data
   * @return {object} updateProfil
   */
  async updatePersonalData(data, newMail = null) {
    let {namtitleTyp, anredeTyp, email, vorname, nachname} = data;

    if (newMail) {
      email = newMail;
    }

    [vorname, nachname] = escapeMetisVariables(vorname, nachname);

    const request = metis.metisRequest({
      query: `
        mutation {
          updateProfil(
            mandantennummer: ${wp.mandantennummer},
            anmeldeEmail: "${email}",
            namtitleTyp: ${namtitleTyp},
            anredeTyp: ${anredeTyp},
            vorname: "${vorname}",
            nachname: "${nachname}"
          ){
            ${profileFields}
          }
        }`,
    });

    const response = await request;
    if (response) {
      return response.updateProfil;
    }
  }

  /**
   * Update birthday and gender
   *
   * @param {object} data
   * @returns
   */
  async updateGenderBithday(data) {
    let {id, gTyp, gebdat, gebort} = data;
    [gebort] = escapeMetisVariables(gebort);

    // remove timestamp
    if (gebdat && gebdat.includes('T')) {
      gebdat = gebdat.split('T')[0]
    }
    console.log("update string", gebdat);

    const request = metis.metisRequest({
      query: `
        mutation {
          updateGeschlechtUndGeburtsdatum(geschlechtUndGeburtsdatumId: ${id}, ${gebdat ? 'gebdat: "' + gebdat + '",' : ''} gebort: "${gebort}", gTyp: ${gTyp}) {
            ${genderBirthdayFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.updateGeschlechtUndGeburtsdatum;
    }
  }

  async createGenderBithday(data, ignoreFormat) {
    let {gTyp, gebdat, gebort, buchung} = data;
    [gebort] = escapeMetisVariables(gebort);

    let birthday = null;
    if (gebdat) {
      if (gebdat.includes('-')) {
        gebdat = gebdat.replace(/-/g, '.');
      }
      if (gebdat.includes('/')) {
        gebdat = gebdat.replace(/\//g, '.');
      }
      birthday = dateFormat.restoreFormat(gebdat, '.');
    }


    console.log("create string", birthday);
    const request = metis.metisRequest({
      query: `
      mutation {
        createGeschlechtUndGeburtsdatum(${birthday ? 'gebdat: "' + birthday + '",' : ''} gebort: "${gebort}", gTyp: ${gTyp} ${buchung === true ? ', buchung: J' : ''}) {
          ${genderBirthdayFields}
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.createGeschlechtUndGeburtsdatum;
    }
  }

  async createGenderBithdayProfile(data, ignoreFormat) {
    let {gTyp, gebdat, gebort} = data;
    [gebort] = escapeMetisVariables(gebort);

    // remove timestamp
    if (gebdat && gebdat.includes('T')) {
      gebdat = gebdat.split('T')[0]
    }
    console.log("create string", gebdat);
    const request = metis.metisRequest({
      query: `
      mutation {
        createGeschlechtUndGeburtsdatum(${gebdat ? 'gebdat: "' + gebdat + '",' : ''} gTyp: ${gTyp}, buchung: J) {
          ${genderBirthdayFields}
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.createGeschlechtUndGeburtsdatum;
    }
  }

  /**
   * Update user password
   *
   * @param {string} password
   * @param {string} new_password
   * @returns {Promise}
   */
  async updatePassword(password, new_password) {
    const request = metis.metisRequest({
      query: `
        mutation{
          changePassword (
            oldPassword: "${password}",
            newPassword: "${new_password}"
          ){
            id
          }
        }`,
    });

    const response = await request;

    notify.emit([
      {
        message: "Das Passwort wurde aktualisiert",
        status: "success",
      },
    ]);

    if (response) {
      return response.changePassword;
    }
  }

  /**
   * Create address data
   *
   * @param {object} data
   */
  async createAdress(data) {
    let {
      aTyp,
      standard,
      str,
      hausnummer,
      strzus,
      plz,
      ort,
      natkz,
      vorname,
      nachname,
      anredeTyp,
    } = data;
    [str, hausnummer, strzus, plz, ort, vorname, nachname] = escapeMetisVariables(str, hausnummer, strzus, plz, ort, vorname, nachname);

    const request = metis.metisRequest({
      query: `
        mutation {
          createAdressdaten(
            aTyp: ${aTyp},
            standard: ${standard},
            str: "${str}",
            hausnr: "${hausnummer}",
            strzus: "${strzus ? strzus : ''}",
            plz:"${plz}",
            natkz: "${natkz}",
            ort: "${ort}",
            anredeTyp: ${anredeTyp},
            vorname: "${vorname}",
            nachname: "${nachname}"
          ){
            ${addressFields}
          }
      }`,
    });

    const response = await request;

    if (response) {
      return response.createAdressdaten;
    }
  }

  /**
   * Create address data
   *
   * @param {object} data
   */
  async createAdressDaten2(data) {
    let {
      aTyp,
      anredeTyp,
      coAnschrift,
      hausnr,
      vorname,
      nachname,
      name1,
      name2,
      name3,
      name4,
      namtitleTyp,
      natkz,
      ort,
      plz,
      str,
      strzus,
      standard,
    } = data;

    [coAnschrift, hausnr, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus] = escapeMetisVariables(coAnschrift, hausnr, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus);

    const request = metis.metisRequest({
      query: `
        mutation {
          createAdressdaten(
            aTyp: ${aTyp},
            anredeTyp: ${anredeTyp},
            coAnschrift: "${coAnschrift ? coAnschrift : ""}",
            hausnr: "${hausnr}",
            vorname: "${vorname}",
            nachname: "${nachname}",
            name1: "${name1 ? name1 : ''}",
            name2: "${name2 ? name2 : ''}",
            name3: "${name3 ? name3 : ''}",
            name4: "${name4 ? name4 : ''}",
            namtitleTyp: ${namtitleTyp},
            natkz: "${natkz}",
            ort: "${ort}",
            plz: "${plz}",
            str: "${str}",
            strzus: "${strzus ? strzus : ''}",
            standard: ${standard}
          ) {
            ${addressFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.createAdressdaten;
    }
  }

  /**
   * Update address data
   *
   * @param {object} data
   */
  async updateAdress(data) {
    let {
      id,
      aTyp,
      standard,
      str,
      hausnummer,
      coAnschrift,
      strzus,
      plz,
      ort,
      natkz,
      vorname,
      nachname,

      name1,
      name2,
      name3,
      name4,
      namtitleTyp,

      anredeTyp,
    } = data;

    [coAnschrift, hausnummer, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus] = escapeMetisVariables(coAnschrift, hausnummer, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus);

    const request = metis.metisRequest({
      query: `
        mutation {
          updateAdressdaten(
            adressdatenId: ${id},
            aTyp: ${aTyp},
            anredeTyp: ${anredeTyp},
            coAnschrift: "${coAnschrift ? coAnschrift : ""}",
            hausnr: "${hausnummer}",
            vorname: "${vorname}",
            nachname: "${nachname}",
            name1: "${name1 ? name1 : ""}",
            name2: "${name2 ? name2 : ""}",
            name3: "${name3 ? name3 : ""}",
            name4: "${name4 ? name4 : ""}",
            namtitleTyp: ${namtitleTyp ? namtitleTyp : "KA"},
            natkz: "${natkz}",
            ort: "${ort}",
            plz: "${plz}",
            str: "${str}",
            strzus: "${strzus ? strzus : ""}",
            standard: ${standard}
          ) {
            ${addressFields}
          }
        }`,
    });
    const response = await request;

    if (response) {
      return response.updateAdressdaten;
    }
  }

  async updateAdressDaten2(data) {
    let {
      adressdatenId,
      aTyp,
      anredeTyp,
      coAnschrift,
      hausnr,
      vorname,
      nachname,
      name1,
      name2,
      name3,
      name4,
      namtitleTyp,
      natkz,
      ort,
      plz,
      str,
      strzus,
      standard,
    } = data;

    [coAnschrift, hausnr, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus] = escapeMetisVariables(coAnschrift, hausnr, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus);

    const request = metis.metisRequest({
      query: `
        mutation {
          updateAdressdaten(
            adressdatenId: ${adressdatenId},
            aTyp: ${aTyp},
            anredeTyp: ${anredeTyp},
            coAnschrift: "${coAnschrift ? coAnschrift : ""}",
            hausnr: "${hausnr}",
            vorname: "${vorname}",
            nachname: "${nachname}",
            name1: "${name1 ? name1 : ''}",
            name2: "${name2 ? name2 : ''}",
            name3: "${name3 ? name3 : ''}",
            name4: "${name4 ? name4 : ''}",
            namtitleTyp: ${namtitleTyp},
            natkz: "${natkz}",
            ort: "${ort}",
            plz: "${plz}",
            str: "${str}",
            strzus: "${strzus ? strzus : ''}",
            standard: ${standard}
          ) {
            ${addressFields}
          }
        }
      `,
    });

    const response = await request;

    if (response) {
      return response.updateAdressdaten;
    }
  }

  /**
   * Create address data
   *
   * @param {object} data
   */
  async updateAdressDaten2(data) {
    let {
      adressdatenId,
      aTyp,
      anredeTyp,
      coAnschrift,
      hausnr,
      vorname,
      nachname,
      name1,
      name2,
      name3,
      name4,
      namtitleTyp,
      natkz,
      ort,
      plz,
      str,
      strzus,
      standard,
    } = data;

    [coAnschrift, hausnr, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus] = escapeMetisVariables(coAnschrift, hausnr, vorname, nachname, name1, name2, name3, name4, ort, plz, str, strzus);

    const request = metis.metisRequest({
      query: `
        mutation {
          updateAdressdaten(
            adressdatenId: ${adressdatenId},
            aTyp: ${aTyp},
            anredeTyp: ${anredeTyp},
            coAnschrift: "${coAnschrift ? coAnschrift : ""}",
            hausnr: "${hausnr}",
            vorname: "${vorname}",
            nachname: "${nachname}",
            name1: "${name1 ? name1 : ''}",
            name2: "${name2 ? name2 : ''}",
            name3: "${name3 ? name3 : ''}",
            name4: "${name4 ? name4 : ''}",
            namtitleTyp: ${namtitleTyp},
            natkz: "${natkz}",
            ort: "${ort}",
            plz: "${plz}",
            str: "${str}",
            strzus: "${strzus ? strzus : ''}",
            standard: ${standard}
          ) {
            ${addressFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.updateAdressdaten;
    }
  }

  /**
   * Remove address from profile
   *
   * @param {string} key
   * @returns
   */
  async removeAddress(key) {
    const request = metis.metisRequest({
      query: `
        mutation{
          deleteAdressdaten(adressdatenId: ${key})
        }`,
    });
    const response = await request;

    if (response) {
      return response.deleteAdressdaten;
    }
  }

  /**
   * Add communication details
   * @param {object} data
   */
  async createKommunikationsdaten(data) {
    let {
      komTyp,
      ansprechpa,
      komEmail,
      rufNrFax,
      rufNrFon,
      rufNrMob,
      standard,
    } = data;

    [ansprechpa, rufNrFax, rufNrFon, rufNrMob] = escapeMetisVariables(ansprechpa, rufNrFax, rufNrFon, rufNrMob);

    console.log(data);

    const request = metis.metisRequest({
      query: `
        mutation{
          createKommunikationsdaten(komTyp: ${komTyp}, ansprechpa: "${ansprechpa}", komEmail: "${komEmail}", rufNrFax: "${rufNrFax}", rufNrFon: "${rufNrFon}", rufNrMob: "${rufNrMob}", standard: ${standard}){
            ${commDataFields}
          }
        }
      `,
    });
    const response = await request;

    if (response) {
      return response.createKommunikationsdaten;
    }
  }

  async getUserKommunikationsdaten(type = null) {
    let request = null;
    if (type) {
      request = metis.metisRequest({
        query: `
          query{
            getUserKommunikationsdaten(kTyp: ${type}){
              ${commDataFields}
            }
          }`,
      });
    } else {
      request = metis.metisRequest({
        query: `
          query{
            getUserKommunikationsdaten{
              ${commDataFields}
            }
          }`,
      });
    }

    const response = await request;

    if (response) {
      return response.getUserKommunikationsdaten;
    }
  }

  async updateKommunikationsdaten(data) {
    let {
      id,
      komTyp,
      ansprechpa,
      komEmail,
      rufNrFon,
      rufNrFax,
      rufNrMob,
      standard,
    } = data;

    [ansprechpa, rufNrFax, rufNrFon, rufNrMob] = escapeMetisVariables(ansprechpa, rufNrFax, rufNrFon, rufNrMob);

    const request = metis.metisRequest({
      query: `
        mutation {
          updateKommunikationsdaten(kommunikationsdatenId: ${id}, komTyp: ${komTyp}, ansprechpa: "${ansprechpa}", komEmail: "${komEmail}", rufNrFax: "${rufNrFax}", rufNrFon: "${rufNrFon}", rufNrMob: "${rufNrMob}", standard: ${standard} ) {
            ${commDataFields}
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.updateKommunikationsdaten;
    }
  }

  async deleteKommunikationsdaten(id) {
    const request = metis.metisRequest({
      query: `
        mutation {
          deleteKommunikationsdaten(kommunikationsdatenId: ${id})
        }`,
    });

    const response = await request;

    if (response) {
      return response.deleteKommunikationsdaten;
    }
  }


  async createbankData(data) {
    // const { einzug, kontoinh, iban, bic, auslbankv, standard } = data;
    let {einzug, kontoinh, iban, standard} = data;
    [kontoinh] = escapeMetisVariables(kontoinh);

    const request = metis.metisRequest({
      query: `
        mutation  {
          createBankdaten(einzug: ${einzug} , kontoinh: "${kontoinh}", iban: "${iban}", standard: ${standard} ) {
            ${bankDataFields}
          }
        }`,
    });

    // auslbankv nach iban einfügen wenn benötigt

    const response = await request;

    if (response) {
      return response.createBankdaten;
    }
  }

  async updatebankData(data) {
    // const {bankdatenId, einzug, kontoinh, iban, bic, auslbankv, standard } = data;
    let {id: bankdatenId, einzug, kontoinh, iban, standard} = data;
    [kontoinh] = escapeMetisVariables(kontoinh);

    const request = metis.metisRequest({
      query: `
        mutation  {
          updateBankdaten(bankdatenId: ${bankdatenId}, einzug: ${einzug} , kontoinh: "${kontoinh}", iban: "${iban}", standard: ${standard} ) {
            ${bankDataFields}
          }
        }`,
    });

    // auslbankv nach iban einfügen wenn benötigt

    const response = await request;

    if (response) {
      return response.updateBankdaten;
    }
  }

  async deleteBankdaten(id) {
    const request = metis.metisRequest({
      query: `
        mutation {
          deleteBankdaten(bankdatenId: ${id})
        }`,
    });

    const response = await request;

    if (response) {
      return response.deleteBankdaten;
    }
  }

  async addAdressdatenToKommunikationsdaten(kommunikationsdatenId, adressdatenId) {
    const request = metis.metisRequest({
      query: `
      mutation {
        addAdressdatenToKommunikationsdaten(
          kommunikationsdatenId: ${kommunikationsdatenId}
          adressdatenId: ${adressdatenId}
        )
      }`,
    });

    const response = await request;

    if (response) {
      return response.addAdressdatenToKommunikationsdaten;
    }
  }

  async addGeschlechtUndGeburtsdatumToKommunikationsdaten(kommunikationsdatenId, geschlechtUndGeburtsdatumId) {
    // console.log('call', kommunikationsdatenId, geschlechtUndGeburtsdatumId);
    const request = metis.metisRequest({
      query: `
      mutation {
        addGeschlechtUndGeburtsdatumToKommunikationsdaten(
          kommunikationsdatenId: ${kommunikationsdatenId}
          geschlechtUndGeburtsdatumId: ${geschlechtUndGeburtsdatumId}
        )
      }`,
    });

    const response = await request;

    if (response) {
      return response.addGeschlechtUndGeburtsdatumToKommunikationsdaten;
    }
  }

  async isEmailValide(email) {
    const request = metis.metisRequest(
      {
        query: `
        query{
          isEmailValide(mandantennummer: ${wp.mandantennummer}, email: "${email}")
        }`,
      },
      false,
      true
    );

    const response = await request;

    if (request) {
      return response;
    }
  }

  async validatePassword(password) {
    const request = metis.metisRequest({
      query: `
        query{
          validatePassword(password: "${password}")
        }`,
    });

    const response = await request;

    if (request) {
      return response;
    }
  }

  async requestPasswordResetToken(email) {
    // console.log(wp);
    const request = metis.metisRequest({
      query: `
        mutation {
          forgotPasswordMail(anmeldeEmail: "${email}", mandantennummer: ${wp.mandantennummer})
        }
      `,
    });

    const response = await request;

    if (response) {
      return response;
    }

    if (request) {
      return response;
    }
  }

  async recoverPassword(data) {
    const {token, email, passwort} = data;

    const request = metis.metisRequest({
      query: `
        mutation{
          changePasswordWithToken(mandantennummer: ${wp.mandantennummer}, anmeldeEmail: "${email}", token: "${token}", newPassword: "${passwort}"){
            id
            identKey
            email
          }
        }`,
    });

    const response = await request;

    if (response) {
      return response.changePasswordWithToken;
    }
  }

  async isDozent() {
    const request = metis.metisRequest({
      query: `
      query{
        isDozent
      }`,
    });

    const response = await request;

    if (response) {
      return response.isDozent;
    }

    return false;
  }

  async checkIfProfileIsPublic() {
    const request = metis.metisRequest({
      query: `
        query{
          isDozentenProfilOeffentlich
        }`,
    });

    const response = await request;

    if (response) {
      return response.isDozentenProfilOeffentlich;
    }

    return false;
  }

  async makeProfilePublic(veroeffentlichen) {
    const request = metis.metisRequest({
      query: `
        mutation {
          alleDozentProfilMerkmaleVeroeffentlichen(veroeffentlichen: ${veroeffentlichen})
        }
      `,
    });

    const response = await request;

    if (response) {
      return response.alleDozentProfilMerkmaleVeroeffentlichen;
    }

    return null;
  }

  async getDozenProfilGruppen() {
    const request = metis.metisRequest({
      query: `
      query{
        getDozenProfilGruppen(mandantennummer: ${wp.mandantennummer}){
          id
          bezeichnung
          bemerkung
          dozentProfilMerkmale{
            id
            bezeichnung
            bemerkung
            sortierungsnr
          }
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.getDozenProfilGruppen;
    }
    return null;
  }

  async getAllKlassigruppen() {
    const request = metis.metisRequest({
      query: `
      query{
         getAllKlassigruppen(mandantennummer: ${wp.mandantennummer}) {
          id
          name
          klassimerkmale {
            id
            klassiname
          }
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.getAllKlassigruppen;
    }
    return null;
  }

  async getUserBuchungen() {
    const request = metis.metisRequest({
      query: `
      query{
        getUserBuchungen {
          gesamtbuchungKey
          buchungKey
          kurs {
            kursnr
            kursbez
            stornotag
            anfang
            ende
          }
          profil {
            vorname
            nachname
          }
          rechnungsadresse {
            hausnr
            vorname
            nachname
            name1
            name2
            name3
            name4
            ort
            plz
            str
            strzus
            coAnschrift
            ansprechpartnerVorname
            ansprechpartnerNachname
            ansprechpartnerAnrede {
              langbezeichnung
            }
          }
          lieferadresse {
            hausnr
            vorname
            nachname
            name1
            name2
            name3
            name4
            ort
            plz
            str
            strzus
            coAnschrift
          }
          korrespondenzadresse {
            hausnr
            vorname
            nachname
            name1
            name2
            name3
            name4
            ort
            plz
            str
            strzus
            coAnschrift
          }
          bankdaten {
            einzug
            kontoinh
            bank
            iban
            bic
          }
          kommunikationsdaten {
            ansprechpa
            komEmail
            rufNrFax
            rufNrFon
            rufNrMob
            adressdaten {
              vorname
              nachname
            }
          }
          geschlechtUndGeburtsdatum {
            gebdat
          }
          preis
          originalpreis
          zwischensumme
          buchungAddons {
            id
            preis
            gesamtpreis
            anzahl
          }
          guthaben {
            minBetrag
          }
          buchungsstatus {
            kurzbezeichnung
            langbezeichnung
          }
          zahlungsart {
            kurzbezeichnung
            langbezeichnung
          }
          bemerkung
          bestellnummer
          warteliste
          fremd
          createTime
          gutscheine {
            gutschein {
              bezeichnung
            }
            minBetrag
          }
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.getUserBuchungen;
    }
    return null;
  }

  async buchungStornieren(key) {
    const request = metis.metisRequest({
      query: `
      mutation {
       buchungStornieren(buchungKey: "${key}")
      }`,
    });
    const response = await request;
    if (response) {
      return response.buchungStornieren;
    }
    return null;
  }

  async getUserDozentenKlassimerkmale() {
    const request = metis.metisRequest({
      query: `
      query{
       getUserDozentenKlassimerkmale {
          id
          profilKlassimerkmal {
            id
            klassiname
          }
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.getUserDozentenKlassimerkmale;
    }
    return null;
  }

  async addDozentenKlassimerkmale(klassiId) {
    const request = metis.metisRequest({
      query: `
      mutation{
        addDozentenKlassimerkmale(klassiId: ${klassiId}) {
          id
          profilKlassimerkmal {
            id
            klassiname
          }
          updateTime
          createTime
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.addDozentenKlassimerkmale;
    }
    return null;
  }

  async deleteDozentenKlassimerkmale(klassiId) {
    const request = metis.metisRequest({
      query: `
      mutation{
        deleteDozentenKlassimerkmale(dozMerkId: ${klassiId}) {
          id
          profilKlassimerkmal {
            id
            klassiname
          }
          updateTime
          createTime
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.deleteDozentenKlassimerkmale;
    }
    return null;
  }

  async getProfilePicture() {
    const request = metis.metisRequest({
      query: `
      query {
        getProfilbild {
          title
          bild
          altText
          mimetype
        }
      }`,
    });

    const response = await request;

    if (response) {
      return response.getProfilbild;
    }

    return null;
  }

  async getDozentProfile() {
    const request = metis.metisRequest({
      query: `
      query{
        getDozentProfile{
          dozentProfilMerkmal{
            id
          }
          text
          profilanzeige
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.getDozentProfile;
    }
    return null;
  }

  async addDozentenMerkmal(dozentProfilMerkmalId, text) {
    [text] = escapeMetisVariables(text);
    const request = metis.metisRequest({
      query: `
      mutation{
        addDozentenMerkmal(dozentProfilMerkmalId: ${dozentProfilMerkmalId}, text: "${text}"){
          dozentProfilMerkmal{
            id
            bezeichnung
            bemerkung
            sortierungsnr
          }
          text
          profilanzeige
        }
      }`,
    });
    const response = await request;
    if (response) {
      return response.addDozentenMerkmal;
    }
    return null;
  }

  async deleteDozentenMerkmal(dozentProfilMerkmalId) {
    const response = await metis.metisRequest({
      query: `
      mutation{
        deleteDozentenMerkmal(dozentProfilMerkmalId: ${dozentProfilMerkmalId}){
          dozentProfilMerkmal{
            id
            bezeichnung
            bemerkung
            sortierungsnr
          }
          text
          profilanzeige
        }
      }`,
    });

    if (response) {
      return response.deleteDozentenMerkmal;
    }
    return null;
  }

  async removeProfilePicture() {
    const request = await metis.metisRequest({
      query: `
      mutation{
        deleteProfilbild
      }`,
    });

    console.log(request.deleteProfilbild);

    if (request.deleteProfilbild) {
      notify.emit([
        {message: "Profilbild wurde gelöscht", status: "success"},
      ]);
      return request.deleteProfilbild;
    }
  }


  async resendConfirmMail(anmeldeEmail) {
    const response = await metis.metisRequest({
      query: `
        mutation{
          resendConfirmMail(anmeldeEmail: "${anmeldeEmail}", mandantennummer: ${wp.mandantennummer})
        }`,
    });

    if (response && response.resendConfirmMail) {
      return response.resendConfirmMail;
    }
    return null;
  }
}

export default UserProfile;
